import { Api, ConfigHelper, createApiService } from 'relapp-api';

export default {
    ...createApiService('customers'),

    /**
     * Give access to the customer.
     *
     * @param {object} customer
     *
     * @return {Promise}
     */
    giveAccess(customer) {
        const url = ConfigHelper.apiUrl('customers.give-access', [
            {
                key: '{customer}',
                value: customer.id
            }
        ]);

        return Api.post(url);
    }
};
